import { createAction } from 'redux-actions';

export const GetListRegistSeminarRequested = createAction('GET_LIST_REGIST_SEMINAR_REQUESTED');
export const GetListRegistSeminarRequestedReceived = createAction('GET_LIST_REGIST_SEMINAR_REQUESTED_RECEIVED');
export const GetListRegistSeminarRequestedReceivedFailure = createAction('GET_LIST_REGIST_SEMINAR_REQUESTED_RECEIVED_FAILURE');
export const ClearListLRegistSeminar = createAction('CLEAR_LIST_REGIST_SEMINAR');

export const getDetailOrderSeminarRequested = createAction('GET_DETAIL_ORDER_SEMINAR_REQUESTED');
export const getDetailOrderSeminarRequestedReceived = createAction('GET_DETAIL_ORDER_SEMINAR_REQUESTED_RECEIVED');
export const getDetailOrderSeminarRequestedReceivedFailure = createAction('GET_DETAIL_ORDER_SEMINAR_REQUESTED_RECEIVED_FAILURE');
export const clearDetailOrderSeminarData = createAction('CLEAR_DETAIL_ORDER_SEMINAR_DATA');

export const UpdateStatusRegistSeminarRequested = createAction('UPDATE_STATUS_REGIST_SEMINAR_REQUESTED');
export const UpdateStatusRegistSeminarRequestedReceived = createAction('UPDATE_STATUS_REGIST_SEMINAR_REQUESTED_RECEIVED');
export const UpdateStatusRegistSeminarRequestedReceivedFailure = createAction('UPDATE_STATUS_REGIST_SEMINAR_REQUESTED_RECEIVED_FAILURE');
export const ClearUpdateStatusRegistSeminarRequested = createAction('CLEAR_UPDATE_STATUS_REGIST_SEMINAR_REQUESTED');

export const resentMailSeminarRequested = createAction('RESENT_MAIL_SEMINAR_REQUESTED');
export const resentMailSeminarRequestedReceived = createAction('RESENT_MAIL_SEMINAR_REQUESTED_RECEIVED');
export const resentMailSeminarRequestedReceivedFailure = createAction('RESENT_MAIL_SEMINAR_REQUESTED_RECEIVED_FAILURE');
export const clearMailSeminar = createAction('CLEAR_MAIL_SEMINAR');
